<template>
    <el-dialog
        align-center
        v-model="state.visible"
        :title="state.title"
        width="900"
        draggable
    >
        <div class="tip">{{ t('deviceWorkTime.tip') }}</div>
        <el-table :data="state.list" v-loading="state.loading" border stripe max-height="420">
            <el-table-column type="index" :label="t('table.index')" width="60" />
            <el-table-column prop="real_name" :label="t('deviceWorkTime.machinist')" min-width="100" />
            <el-table-column prop="mobile" :label="t('field.mobile')" min-width="120" />
            <el-table-column prop="work_days" :label="t('deviceWorkTime.workDays')" width="90" />
            <el-table-column prop="standard_time" :label="t('deviceWorkTime.standardTime')" width="100" />
            <el-table-column prop="ot_time" :label="t('deviceWorkTime.otTime')" width="100" />
            <el-table-column prop="zhi_time" :label="t('deviceWorkTime.zhiTime')" width="100" />
            <el-table-column prop="tongxiao_time" :label="t('deviceWorkTime.tongxiaoTime')" width="100" />
            <el-table-column prop="total_time" :label="t('deviceWorkTime.totalShort')" width="90" />
        </el-table>
        <template #footer>
            <el-button @click="state.visible = false">{{ t('deviceWorkTime.close') }}</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { reactive, defineExpose } from "vue";
import { ElMessage } from "element-plus";
import { workTimeStatsOperatorsApi } from "@/api/system/device";
import { usePageI18n } from '@/composables/usePageI18n.js';

const applyLabels = () => {};
const { t } = usePageI18n(applyLabels);

const state = reactive({
    visible: false,
    loading: false,
    title: "",
    list: [],
});

const open = (row, month, site = "") => {
    if (!row?.id || !month) {
        ElMessage.warning(t('deviceWorkTime.missingDeviceMonth'));
        return;
    }
    const siteLabel = site ? ` · ${site}` : "";
    const deviceLabel = row.title || row.code || t('detail.deviceLabel');
    state.title = `${deviceLabel} · ${month}${siteLabel} · ${t('deviceWorkTime.operatorBreakdown')}`;
    state.visible = true;
    state.loading = true;
    state.list = [];
    const payload = {
        device_list_id: row.id,
        time: month,
    };
    if (site) {
        payload.site = site;
    }
    workTimeStatsOperatorsApi(JSON.stringify(payload))
        .then((res) => {
            state.list = res?.data ?? [];
        })
        .catch(() => {
            state.list = [];
            ElMessage.error(t('deviceWorkTime.loadFailed'));
        })
        .finally(() => {
            state.loading = false;
        });
};

defineExpose({ open });
</script>

<style lang="less" scoped>
.tip {
    margin-bottom: 12px;
    font-size: 13px;
    color: #909399;
}
</style>
